import { sanitizeForUrl } from './sanitizeForUrl.js';

// This file is used by both es6 modules and commonJS on build, so can't convert to .ts
export const getArticlePath = (slug) =>
  `/resource-center/articles/${sanitizeForUrl(slug ?? '')}`;

export default getArticlePath;
